export default __webpack_public_path__ + "static/media/world.f67e0ffa.svg";